export default "__VITE_ASSET__9de8df36__"